import { render, staticRenderFns } from "./mgmtReaders.vue?vue&type=template&id=ed52f1b2&scoped=true&"
import script from "./mgmtReaders.vue?vue&type=script&lang=js&"
export * from "./mgmtReaders.vue?vue&type=script&lang=js&"
import style0 from "./mgmtReaders.vue?vue&type=style&index=0&id=ed52f1b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed52f1b2",
  null
  
)

export default component.exports